<svg [ngClass]="iconClassName" [attr.aria-hidden]="iconShouldBeHidden">
  <use [attr.href]="'assets/icons/sprite/icons.svg#' + iconName"/>
</svg>

